import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card, CardHeader, CardContent } from '../components/ui/Card';
import { RiskMatrix } from '../components/orgPsychology/RiskMatrix';
import { Button } from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';

const mockRisks = [
  { label: 'Utbrenthet i IT', x: 4, y: 4 },
  { label: 'Relasjonskonflikt Salg', x: 3, y: 2 },
  { label: 'Rolleuklarhet Adm', x: 2, y: 1 },
  { label: 'Tidspress Support', x: 4, y: 3 }
];

export const PsychosocialRiskMatrix = () => {
  return (
    <div className="space-y-8 pb-20">
      <PageHeader 
        title="Psykososial Risikomatrise" 
        intro="Visualisering av identifiserte risikofaktorer basert på sannsynlighet og konsekvens for driften."
        breadcrumb="Analyse / Risiko / Matrise"
        actions={<Button variant="primary" icon={<SafeIcon name="Plus" />}>Legg til Risiko</Button>}
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <Card className="border-none shadow-xl">
            <CardHeader title="Risikobilde: Virksomheten" subtitle="Aggregert oversikt over alle avdelinger" />
            <CardContent className="p-10">
              <RiskMatrix data={mockRisks} />
            </CardContent>
          </Card>
        </div>

        <div className="space-y-6">
          <Card>
            <CardHeader title="Aktive Risikofaktorer" />
            <CardContent className="p-0">
              <div className="divide-y divide-slate-100">
                {mockRisks.map((risk, i) => (
                  <div key={i} className="p-4 flex justify-between items-center hover:bg-slate-50 transition-colors">
                    <div>
                      <p className="text-sm font-bold text-slate-900">{risk.label}</p>
                      <p className="text-[10px] text-slate-400 uppercase font-black">S:{risk.x + 1} K:{risk.y + 1}</p>
                    </div>
                    <div className={`w-2 h-2 rounded-full ${(risk.x + risk.y) > 5 ? 'bg-rose-500' : 'bg-amber-400'}`} />
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          <div className="bg-indigo-900 p-8 rounded-[40px] text-white">
            <SafeIcon name="Zap" className="text-4xl text-indigo-400 mb-4" />
            <h4 className="text-xl font-black uppercase tracking-tighter">AI Prioritering</h4>
            <p className="text-xs text-indigo-200 mt-2 mb-6 leading-relaxed">
              Basert på matrisen bør <b>Utbrenthet i IT</b> adresseres umiddelbart gjennom en "Prioriterings-vask" workshop.
            </p>
            <Button variant="secondary" className="w-full bg-white text-indigo-900 border-none font-black text-[10px] uppercase">Generer Tiltak</Button>
          </div>
        </div>
      </div>
    </div>
  );
};